import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import * as React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import NotFound from '../../../../components/404/404';
import SecuredRoute from '../../../../components/SecuredRoute/SecuredRoute';
import DrawerGroupAdmin from '../../DrawerGroupsAdmin/DrawerGroupsAdmin';
import Home from '../../Home/Home';
import MenuAdmin from '../../MenuAdmin/MenuAdmin';
import SearchTemplate from '../../SearchTemplate/SearchTemplate';
import Tabs from '../../Tabs/Tabs';
import TemplateAdmin from '../../TemplateAdmin/TemplateAdmin';
import './Content.css';

class Content extends React.PureComponent<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      previousLocation: this.props.location
    };
  }

  public componentDidUpdate(nextProps: any) {
    const { location } = this.props;
    // set previousLocation if props.location is not modal
    if (nextProps.history.action !== 'POP' && (!location.state || !location.state.modal)) {
      this.setState({ previousLocation: this.props.location });
    }
  }

  public render(): JSX.Element {
    const { location } = this.props;
    const isModal = !!(location.state && location.state.modal && this.state.previousLocation !== location);

    return (
      <Fabric className="content" style={{ height: '100%' }}>
        <Switch location={isModal ? this.state.previousLocation : location}>
          <SecuredRoute exact={true} path="/search" component={Home} />
          <SecuredRoute exact={true} path="/search/home" component={Home} />

          <SecuredRoute exact={true} path="/search/results" component={Tabs} />
          <SecuredRoute exact={true} path="/search/template/:templateId(\d+)/results" component={Tabs} />

          <SecuredRoute path="/search/template" component={TemplateAdmin} />

          <SecuredRoute path="/search/menu" component={MenuAdmin} />
          <SecuredRoute exact={true} path="/search/template/:templateId(\d+)" component={SearchTemplate} />

          <SecuredRoute path="/search/drawergroups" component={DrawerGroupAdmin} />

          <SecuredRoute component={NotFound} />
        </Switch>

        {isModal ? <Route exact={true} path="/search/template/:templateId(\d+)" component={SearchTemplate} /> : null}
      </Fabric>
    );
  }
}

export default withRouter(Content);
